import { Suspense } from 'react';
import { SDKUsage } from '@gonfalon/billing/components';

import { Card } from '../../shared';
import { Box, Flex } from '../../shared/components';
import { useAccountSubscription } from '../hooks/useAccountSubscription';
import { type Account } from '../model';

import { AccountContextProvider } from './AccountContextProvider';
import { SDKUsageErrorBoundary } from './SDKUsageErrorBoundary';

type SDKUsageTabProps = {
  account: Account;
};

export function SDKUsageTab({ account }: SDKUsageTabProps) {
  const { data: subscription } = useAccountSubscription(account);
  const getApplicationPath = (applicationId: string) =>
    `/accounts/${account._id}/sdks/${encodeURIComponent(applicationId)}`;

  return (
    <div className="SDKUsageTab">
      <Flex>
        <Box width={1} p={2}>
          <Card>
            <SDKUsageErrorBoundary>
              <Suspense fallback={<div>Loading SDK connections…</div>}>
                <AccountContextProvider account={account} subscription={subscription || undefined}>
                  <SDKUsage onApplicationClick={getApplicationPath} />
                </AccountContextProvider>
              </Suspense>
            </SDKUsageErrorBoundary>
          </Card>
        </Box>
      </Flex>
    </div>
  );
}
